import {useEffect} from "react";
import {PRODUCT_NAME} from "../lib/brand";

// The default <title>/description, restored whenever a page that set its
// own stops being mounted - see the cleanup below. Keeps a page that never
// calls this hook (an authenticated, session-gated one - nothing a crawler
// can reach anyway) from inheriting whatever the last public page left
// behind.
const DEFAULT_TITLE = PRODUCT_NAME;
const DEFAULT_DESCRIPTION = "Sprint planning and bug tracking for small teams and game studios.";

// There's no server-side rendering here to set a page's <title> and meta
// description once per route - the static shell (public/index.html) is the
// same for every URL - so this is what actually decides what a crawler
// indexes, or a shared link unfurls, for a given page. Pass a falsy title to
// leave the browser tab showing whatever it already has (a page still
// loading its own data, say) without flashing the site default in between.
export default function usePageMeta(title, description = DEFAULT_DESCRIPTION) {
    useEffect(() => {
        if (title) document.title = title;

        const meta = document.querySelector('meta[name="description"]');
        if (meta && title) meta.setAttribute("content", description);

        return () => {
            document.title = DEFAULT_TITLE;
            if (meta) meta.setAttribute("content", DEFAULT_DESCRIPTION);
        };
    }, [title, description]);
}
